export default __webpack_public_path__ + "static/media/expand.4e854f9f.svg";